export default __webpack_public_path__ + "static/media/room-2.48c60181.jpg";